import { toast } from "react-toastify";

import { buildPrincipalErrorMessages } from "../../../pages/SHARED/Bond Creation/Helpers/principalErrorMessages";

const LENGTH_SENTINEL = "characters or less";

export function formatFieldKeyLabels(fieldKeys) {
  return fieldKeys
    .map((field) => field.replace(/([A-Z])/g, " $1"))
    .map((f) => f.replaceAll(".", " "))
    .map((f) => f.charAt(0).toUpperCase() + f.slice(1))
    .join(", ");
}

function formatMissingFieldLabels(requiredErrors) {
  return formatFieldKeyLabels(requiredErrors.map(([field]) => field));
}

/**
 * Bond wizard Next-button validation UX shared by probate/trustee/VA/guardianship hooks.
 *
 * @param {object} options
 * @param {Record<string, string>} options.currentStepErrors
 * @param {number} options.activeStep
 * @param {number} [options.principalStepIndex=2]
 * @param {typeof toast} [options.toastFn]
 */
export function reportBondStepValidationErrors({
  currentStepErrors,
  activeStep,
  principalStepIndex = 2,
  toastFn = toast,
}) {
  const entries = Object.entries(currentStepErrors);
  const lengthErrors = entries
    .filter(([, msg]) => msg.includes(LENGTH_SENTINEL))
    .map(([, msg]) => msg);
  const requiredErrors = entries.filter(([, msg]) => !msg.includes(LENGTH_SENTINEL));

  if (lengthErrors.length > 0) {
    lengthErrors.forEach((msg) => toastFn.warning(msg));
  }
  if (requiredErrors.length > 0) {
    const principalErrorMessages =
      activeStep === principalStepIndex
        ? buildPrincipalErrorMessages(currentStepErrors)
        : [];

    if (principalErrorMessages.length > 0) {
      principalErrorMessages.forEach((msg) => toastFn.error(msg));
    } else {
      toastFn.error(
        `Please complete the following fields: ${formatMissingFieldLabels(requiredErrors)}`
      );
    }
  }
}

/**
 * Reconcile payload.premium with {@link calculatePremium} at wizard finish.
 *
 * @param {{ premium: number, bond_amount: number }} payload
 * @param {(...args: unknown[]) => number} calculatePremium
 * @param {unknown[]} extraArgs - forwarded after bond_amount (DOB/dateOfDeath, subcategory, bondTerm optional)
 */
export function applyPremiumRecalcToPayload(payload, calculatePremium, extraArgs) {
  const recalculated = calculatePremium(payload.bond_amount, ...extraArgs);
  if (recalculated !== payload.premium) payload.premium = recalculated;
}
